import * as Yup from 'yup';
import checkoutFormModel from './formModel';
import moment from "moment";

const {
    formField: {
        afinidad,
        tipoVivienda,
        codigosLocalidad,
        deducible,
        coberturasAdicionales: {
            sumaAseguradaAdicional,
            numeroCoberturaAdicional,
            selectedCoberturaAdicional
        },
        fechaCotizacion
    }
} = checkoutFormModel;

export default [
    Yup.object().shape({
        [afinidad.name]: Yup.string().required(`${afinidad.requiredErrorMsg}`),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        [tipoVivienda.name]: Yup.string().required(`${tipoVivienda.requiredErrorMsg}`),
        [deducible.name]: Yup.number().integer().required(`${deducible.requiredErrorMsg}`),
        [fechaCotizacion.name]: Yup.date()
            .required(`${fechaCotizacion.requiredErrorMsg}`)
            .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
            .max(moment().add(45, "days").format('YYYY-MM-DD'), "La fecha no puede superar los 45 dias"),
    }),
    Yup.object().shape({
        coberturasAdicionales: Yup.array().of(
            Yup.object().shape(
                {
                    [sumaAseguradaAdicional.name]: Yup.number(),
                    [numeroCoberturaAdicional.name]: Yup.string(),
                    [selectedCoberturaAdicional.name]: Yup.boolean(),
                }
            )
        ),
    }),
];
